import React, { AnchorHTMLAttributes, forwardRef, ForwardRefExoticComponent, RefAttributes } from 'react';
import cx from 'classnames';
import { FlosIcon } from '../../../core/icon/flos-icon';

export interface MessageBoxProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    header: AnchorHTMLAttributes<HTMLAnchorElement>['children'];
    subline?: AnchorHTMLAttributes<HTMLAnchorElement>['children'];
    arrowIconShape?: string;
    highlight?: boolean;
}

type MessageBox = ForwardRefExoticComponent<MessageBoxProps & RefAttributes<HTMLAnchorElement>>;

export const MessageBox: MessageBox = forwardRef(({ header, subline, className, highlight = false, arrowIconShape = 'arrow-right', children, ...props }, forwardedRef) => {
    const hasSubline = !!subline;
    const hasChildren = !!children;
    const hideSubline = !hasSubline && !hasChildren;
    return (
        <a className={cx('message-box', { [`message-box--highlight`]: highlight }, className)} {...props} ref={forwardedRef}>
            <div className={'message-box-main'}>
                <div className={cx('message-box-contents-col')}>
                    <div className={cx('message-box-header-row')}>
                        <h4 className={cx('message-box-header', { ['message-box-header--highlight']: highlight })}>{header}</h4>
                        <span className="message-box-spacer" />
                        <FlosIcon shape={arrowIconShape} size={'xsmall'} className="message-box-arrow-right" />
                    </div>
                    {!hideSubline && (
                        <div className={cx('message-box-subline-row', { ['message-box-subline-row--highlight']: highlight })}>
                            {hasSubline && <p className={cx('message-box-subline')}>{subline}</p>}
                            <span className="message-box-spacer" />
                            {hasChildren && <span className={'message-box-children-playground'}>{children}</span>}
                        </div>
                    )}
                </div>
            </div>
        </a>
    );
});

MessageBox.displayName = 'MessageBox';

export default MessageBox;
